import { MapToolType } from "../../screens/MapScreen";
import styles from "./DropdownSelector.module.css";

import { useState, useEffect } from "react";

/**
 * @author  kim young jun
 * @date    2025-06-11
 * @param   props 
 * @return  Selector
 */

export interface DropdownSelectorItems {
    key: string;
    label: string;
    isActive: boolean;
    isHover: boolean;
}

interface dropdownSelectorProps {
    analysisType: number; // 25.07.03 | Kim Young Jun | 분석 타입 추가
    items: DropdownSelectorItems[];
    selectedKey: string;
    onChange: (key: string, label?: string) => void;
    onMouseOver?: (key: string) => void;
    onMouseOut?: () => void;
    isReverse?: boolean;
    // 25.07.07 | Kim Young Jun | setIsLoading, setLoadingMessage 추가
    setIsLoading: (isLoading: boolean) => void;
    setLoadingMessage: (message: string) => void;
    triggerAnalysis?: () => void;
}



function DropdownSelector(props: dropdownSelectorProps) {
    const [isMobileView, setIsMobileView] = useState(false);

    /**
     * 분석 타입 레이블 맵
     */
    const ANALYSIS_TYPE_LABELS: Record<number, string> = {
        [MapToolType.Choropleth]: "단계구분도",
        [MapToolType.Heat]: "히트맵",
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth <= 780);
        };

        handleResize();

        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);
    
    const items = props.isReverse && !isMobileView
        ? [...props.items].reverse()
        : props.items;

    return (
        <div className={styles.selector_container}>
            <div className={styles.tit_container}>
                <div className={styles.tit}>장소 정보</div>
            </div>
            {items.length === 0 ? (
                <div className={styles.empty_message}>
                    분석 가능한 <b>장소 정보</b>가 없습니다.
                </div>
            ) : (
                <div className={styles.items_container}>
                    {items.map(({ key, label, isActive, isHover }) => (
                        <div
                            key={key}
                            className={styles.item}
                            onClick={() => {
                                // 25.07.07 | Kim Young Jun | setIsLoading, setLoadingMessage 설정
                                const analysisLabel = ANALYSIS_TYPE_LABELS[props.analysisType]

                                 // 같은 매트릭 버튼을 클릭하더라도 항상 분석 실행
                                props.setLoadingMessage(`${analysisLabel} '${label ?? ""}' 항목을 분석중입니다.`);
                                props.setIsLoading(true);
                                
                                // 분석 트리거 함수 추가 (Map 컴포넌트에서 제공)
                                props.triggerAnalysis && props.triggerAnalysis();
                                
                                // 선택된 필드가 변경된 경우에만 onChange 호출
                                if (props.selectedKey !== key) {
                                    props.onChange(key, label)
                                }
                            }}
                            onMouseOver={() => props.onMouseOver?.(key)}
                            onMouseOut={() => props.onMouseOut?.()}
                        >
                            <div className={`${styles.label_container} ${isActive ? styles.active : ""}`}>
                                {label && (
                                    <div className={styles.label_wrapper}>
                                        <span
                                            className={`${styles.label} ${isHover && label.length >= 5 ? styles.label_flow : ""
                                                } ${isActive ? styles.active : isHover ? styles.hover : ""}`}
                                        >
                                            {label}
                                        </span>
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}


export default DropdownSelector;